var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',[_c('div',[_c('span',{staticClass:"mg-15"},[_vm._v("Moonstake © 2020")])]),_c('div',{staticClass:"ml-auto"},[_c('span',[_vm._v("Staking Pool Admin")])])])}
var staticRenderFns = []

export { render, staticRenderFns }